// src/firebase.js
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCCKmh0DHOSjdvMCTvBX2MGDXS34xwOBhU",
  authDomain: "park-ease-valet.firebaseapp.com",
  projectId: "park-ease-valet",
  storageBucket: "park-ease-valet.firebasestorage.app",
  messagingSenderId: "544054856516",
  appId: "1:544054856516:web:54edb5aba20089487aa511",
  measurementId: "G-7S1NQRN17K",
};

// const app = initializeApp(firebaseConfig);
// let analytics;
// if (typeof window !== "undefined") {
//   analytics = getAnalytics(app);
// }
// const messaging = getMessaging(app);
// const auth = getAuth(app);

// export { analytics, messaging,auth };


const app = initializeApp(firebaseConfig);

let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

let messaging = null;

// Check if messaging is supported in this browser
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  } else {
    console.warn("Firebase messaging not supported in this browser.");
  }
});

const auth = getAuth(app);

export { analytics, messaging, auth };